export default "__VITE_ASSET__61aabdf8__"